<script>
    import { tour } from '../tour'
    import { fly } from 'svelte/transition';
    
    // Tooltips
    import Tooltip from './Tooltip.svelte';
    let showingTooltip = false;
    const showTooltip = () => { showingTooltip = true; }
    const hideTooltip = () => { showingTooltip = false; }

    export let prevScene = tour.prevScene;
    export let hideFirst = false;
    
    let sceneIndex = tour.currentScene.getIndex();
    addEventListener('krpano:newpano', () => {
        sceneIndex = tour.currentScene.getIndex();
    });
</script>

<style>
    :root {
        --prev-scene-bg-color-rgb: var(--theme-color-rgb);
    }

    div {
        background: rgba(var(--prev-scene-bg-color-rgb), 0.8);
        color: white;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        z-index: 999;
        border-radius: 0 10px 10px 0;
        cursor:pointer;
        padding: 20px 20px 20px 10px;
    }

    div:hover {
        background: rgba(var(--prev-scene-bg-color-rgb), 1);
        border: 3px solid rgba(255,255,255,1);
        border-width: 3px 3px 3px 0;
    }
</style>
{#if !hideFirst || sceneIndex > 0 }
<div class="no-select" on:click="{prevScene}" transition:fly={{x: -300, duration: 500 }} on:mouseenter={showTooltip} on:mouseleave={hideTooltip}>
    <Tooltip text="Previous Location" showingTooltip={showingTooltip} position={'right'} />
    <img src="./images/direction.png" width="35" height="35" alt="Previous Location"/>
</div>
{/if}
